import { getListsMulti } from '../helpers'

/**
 * Chains whose token lists carry `props.receipt` rows — Dolomite's
 * isolation-mode factories today (Arbitrum is 39 of the 47; Mantle and
 * Berachain the rest). Kept explicit: fetching every chain's list on the
 * yields tick would be ~140 requests for nothing.
 */
export const RECEIPT_CHAINS = ['42161', '5000', '80094']

/**
 * A RECEIPT (token-list `props.receipt`, e.g. Dolomite's `dGM`/`dsavETH`
 * isolation tokens) tracks its `underlying` 1:1 and earns what it earns — but
 * it has its own `assetGroup`, and every consumer of this map joins by the
 * ROW's group: margin-fetcher's own converters (patched to look through to
 * the underlying) and, more importantly, the origin's
 * `asset_intrinsic_yield_latest` table, which is keyed by the dToken's group
 * with no notion of "underlying". So the map carries the underlying's rate
 * under the receipt's group as well; nothing downstream has to know the
 * relation. A receipt whose underlying has no rate stays absent (never 0).
 */
export async function propagateReceiptYields(intrinsicYields: {
  [asset: string]: number | undefined
}): Promise<void> {
  let lists: any
  try {
    lists = await getListsMulti(RECEIPT_CHAINS)
  } catch {
    return
  }
  for (const chainId of RECEIPT_CHAINS) {
    const list: Record<string, any> = lists?.[chainId]?.list ?? {}
    for (const token of Object.values(list)) {
      const receipt = token?.props?.receipt
      if (!receipt?.underlying || !token.assetGroup) continue
      if (intrinsicYields[token.assetGroup] !== undefined) continue
      const underlying = list[String(receipt.underlying).toLowerCase()]
      const rate = underlying?.assetGroup
        ? intrinsicYields[underlying.assetGroup]
        : undefined
      if (rate !== undefined) intrinsicYields[token.assetGroup] = rate
    }
  }
}
